export default [
  {
    path: '/add-contract-template-normal',
    component: resolve => require(['../../views/contract/addContractTemplateNormal'], resolve),
    meta: { title: '新增合同' }
  },
  {
    path: '/contract-list',
    component: resolve => require(['../../views/contract/contractList'], resolve),
    meta: { title: '合同列表' }
  },
  {
    path: '/shop-contract-list',
    component: resolve => require(['../../views/contract/shopContractList'], resolve),
    meta: { title: '合同列表' }
  },
  {
    path: '/org-shop-contract-list',
    component: resolve => require(['../../views/contract/org-shopContractList'], resolve),
    meta: { title: '下属门店合同列表' }
  },
  {
    path: '/mbsend-contract',
    component: resolve => require(['../../views/contract/mbsend-contract'], resolve),
    meta: { title: '移动端发送法大大合同' }
  },

]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/contract.js